'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm = require('react-hook-form');
var SelectCard = require('@circlefin/components/lib/SelectCard');

/**
 * Create Form SelectCard.
 */ function createFormSelectCard() {
    const FormSelectCard = ({ name, value, children, onChange, type = 'radio', ...props })=>{
        const { field } = reactHookForm.useController({
            name
        });
        const { isSubmitting } = reactHookForm.useFormState();
        const disabled = react.useMemo(()=>isSubmitting || props.disabled, [
            isSubmitting,
            props.disabled
        ]);
        const handleChange = react.useCallback((e)=>{
            if (type === 'radio') {
                field.onChange(e);
            } else {
                // For checkboxes, we need to manage an array of selected values.
                const newValue = e.target.value;
                const currentValue = Array.isArray(field.value) ? field.value : [];
                const updatedValue = currentValue.includes(newValue) ? currentValue.filter((v)=>v !== newValue) : [
                    ...currentValue,
                    newValue
                ];
                field.onChange({
                    ...e,
                    target: {
                        ...e.target,
                        value: updatedValue
                    }
                });
            }
            onChange?.(e);
        }, [
            field,
            onChange,
            type
        ]);
        const checked = react.useMemo(()=>{
            if (type === 'radio') {
                return field.value === value;
            }
            // For checkboxes, check if the value is included in the array of selected values
            return Array.isArray(field.value) && field.value.includes(value);
        }, [
            field.value,
            type,
            value
        ]);
        return jsxRuntime.jsx(SelectCard.SelectCard, {
            ...props,
            ...field,
            checked: checked,
            disabled: disabled,
            name: name,
            onChange: handleChange,
            type: type,
            value: value,
            children: children
        });
    };
    FormSelectCard.displayName = 'Form.SelectCard';
    return FormSelectCard;
}

exports.createFormSelectCard = createFormSelectCard;
//# sourceMappingURL=Form.SelectCard.js.map
